export default {
    values: {
        'LIVE Event ID': 'ID de evento do LIVE'
    }
}
